/**
 * Front-end minimal implementation of Java.Time.Period
 * Useful for finding the difference between two date objects.
 * For our use we have only looked at months and years.
 *
 * Example usage:
 * const period : Period = Period.between(new LocalDate('2018-01-01), new LocalDate('2019-03-01));
 * const years = period.years; //returns 1
 * const months = period.months //returns 2
 * const totalMonths = period.totalMonths //returns 14
 *
 * const prettyPrintedDateOfBirth = fnr.dateOfBirth.toLocaleString()
 */
var Period = /** @class */ (function () {
    function Period(years, months) {
        this.years = years;
        this.months = months;
        this.totalMonths = years * 12 + months;
    }
    Period.between = function (start, end) {
        var totalMonths = (end.year - start.year) * 12 + (end.month - start.month);
        var days = end.day - start.day;
        if (totalMonths > 0 && days < 0) {
            totalMonths--;
        }
        else if (totalMonths < 0 && days > 0) {
            totalMonths++;
        }
        var years = Math.trunc(totalMonths / 12); //div operator for positive/negative numbers
        var months = totalMonths % 12 === 0 ? 0 : totalMonths % 12;
        return new Period(years, months);
    };
    /**
     * Checks if both units of this period are zero.
     *
     * A zero period has the value zero for the years and months units.
     *
     * @returns {boolean} True if this period is zero-length.
     */
    Period.prototype.isZero = function () {
        return this.years === 0 && this.months === 0;
    };
    /**
     * Checks if any units of this period are negative.
     *
     * This checks whether the years or months units are less than zero.
     *
     * @returns {boolean} True if any unit of this period is negative.
     */
    Period.prototype.isNegative = function () {
        return this.years < 0 || this.months < 0;
    };
    Period.prototype.toJSON = function () {
        return "P".concat(this.years, "Y").concat(this.months);
    };
    Period.prototype.toString = function () {
        return this.toJSON();
    };
    return Period;
}());
export { Period };
